import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_201_576)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0334 3.03335L17.9667 1.96668C17.873 1.87195 17.7614 1.79674 17.6384 1.74542C17.5153 1.69409 17.3834 1.66766 17.2501 1.66766C17.1168 1.66766 16.9848 1.69409 16.8618 1.74542C16.7388 1.79674 16.6272 1.87195 16.5334 1.96668L2.96674 15.5334C2.87201 15.6271 2.7968 15.7387 2.74548 15.8617C2.69415 15.9848 2.66772 16.1167 2.66772 16.25C2.66772 16.3833 2.69415 16.5153 2.74548 16.6383C2.7968 16.7613 2.87201 16.8729 2.96674 16.9667L4.03341 18.0334C4.1266 18.1291 4.23802 18.2052 4.36112 18.2572C4.48421 18.3092 4.61647 18.3359 4.75008 18.3359C4.88369 18.3359 5.01595 18.3092 5.13904 18.2572C5.26213 18.2052 5.37356 18.1291 5.46674 18.0334L19.0334 4.46668C19.1292 4.3735 19.2053 4.26207 19.2572 4.13898C19.3092 4.01589 19.336 3.88363 19.336 3.75002C19.336 3.6164 19.3092 3.48415 19.2572 3.36105C19.2053 3.23796 19.1292 3.12653 19.0334 3.03335Z",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6667 5.83331L15.1667 8.33331",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.16675 5V8.33333",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.8333 11.6666V15",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33325 1.66669V3.33335",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.83333 6.66669H3.5",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5001 13.3334H15.1667",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1667 2.5H8.5",
				stroke: "#3C59F6",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_201_576",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgMagicPen;
